import { useQuery } from "@tanstack/react-query"
import { Guid } from "../app/models/CustomType"
import { UserApplicationGet } from "../app/models/UserApplication"
import { digitalManagerApi } from "../services/api"

export function useUserApplications(userId?: Guid) {
  const { data: userApplications = [], isLoading: isLoadingUserApplications } = useQuery({
    queryKey: ["userApplications", userId],
    queryFn: () =>
      digitalManagerApi
        .get<UserApplicationGet[]>(`/users/${userId}/applications`)
        .then((r) => r.data),
    enabled: !!userId,
  })

  return {
    userApplications,
    isLoadingUserApplications,
  }
}
